import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    const curtain = this.element.querySelector('.curtain');
    if (curtain) {
        curtain.addEventListener('click', 
        (e) => {
            const componentRoot = e.target.closest('.alternating-grid-listing');
            if (componentRoot) {
                const link = componentRoot.querySelector('a');
                const href = link ? link.getAttribute('href') : '#';
                window.location = href;
            }
        }, 
        { capture: false, passive: true, once: true });
    }
  }
}
